import { Action, createReducer, on } from '@ngrx/store';
import { RequestsActions } from './requests.actions';
import { requestsInitialState, RequestsState } from './requests.state';

const _requestsReducer = createReducer(
  requestsInitialState(),

  /**
   * Reducers For Get All Requests
   */

  on(RequestsActions.getAllRequests, (state) => {
    return {
      ...state,
      allRequests: {
        loading: true,
      },
    };
  }),
  on(RequestsActions.getAllRequestsSuccess, (state, { response }) => {
    return {
      ...state,
      allRequests: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(RequestsActions.getAllRequestsFailure, (state, { failure }) => {
    return {
      ...state,
      allRequests: {
        loading: false,
        failure: failure,
      },
    };
  }),

  /**
   * Reducers For Create Request
   */
  on(RequestsActions.createRequest, (state) => {
    return {
      ...state,
      createRequest: {
        loading: true,
      },
    };
  }),
  on(RequestsActions.createRequestSuccess, (state, { requests }) => {
    return {
      ...state,
      createRequest: {
        loading: false,
        data: requests.data,
      },
    };
  }),
  on(RequestsActions.createRequestFailure, (state, { failure }) => {
    return {
      ...state,
      createRequest: {
        loading: false,
        failure: failure,
      },
    };
  }),

  /**
   * Reducers For Edit Request
   */
  on(RequestsActions.editRequest, (state) => {
    return {
      ...state,
      editRequest: {
        loading: true,
      },
    };
  }),
  on(RequestsActions.editRequestSuccess, (state, { requests }) => {
    return {
      ...state,
      editRequest: {
        loading: false,
        data: requests.data,
      },
    };
  }),
  on(RequestsActions.editRequestFailure, (state, { failure }) => {
    return {
      ...state,
      editRequest: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Edit Request
   */
  on(RequestsActions.exportRequests, (state) => {
    return {
      ...state,
      exportRequests: {
        loading: true,
      },
    };
  }),
  on(RequestsActions.exportRequestsSuccess, (state, { response }) => {
    return {
      ...state,
      exportRequests: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(RequestsActions.exportRequestsFailure, (state, { failure }) => {
    return {
      ...state,
      exportRequests: {
        loading: false,
        failure: failure,
      },
    };
  }),

  /**
   * Reducers For Get My Requests
   */
  on(RequestsActions.myRequests, (state) => {
    return {
      ...state,
      myRequests: {
        loading: true,
      },
    };
  }),
  on(RequestsActions.myRequestsSuccess, (state, { response }) => {
    return {
      ...state,
      myRequests: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(RequestsActions.myRequestsFailure, (state, { failure }) => {
    return {
      ...state,
      myRequests: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Get My Requests
   */
  on(RequestsActions.getRequestById, (state) => {
    return {
      ...state,
      requestById: {
        loading: true,
      },
    };
  }),
  on(RequestsActions.getRequestByIdSuccess, (state, { response }) => {
    return {
      ...state,
      requestById: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(RequestsActions.getRequestByIdFailure, (state, { failure }) => {
    return {
      ...state,
      requestById: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Get My Requests Count
   */
  on(RequestsActions.getMyRequestsCount, (state) => {
    return {
      ...state,
      myRequestsCount: {
        loading: true,
      },
    };
  }),
  on(RequestsActions.getMyRequestsCountSuccess, (state, { response }) => {
    return {
      ...state,
      myRequestsCount: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(RequestsActions.getMyRequestsCountFailure, (state, { failure }) => {
    return {
      ...state,
      myRequestsCount: {
        loading: false,
        failure: failure,
      },
    };
  })
);

export function requestsReducer(
  state: RequestsState | undefined,
  action: Action
) {
  return _requestsReducer(state, action);
}
